"use client";
import { useGlobalContext } from "@/context/GlobalProvider";
import { useDialect } from "./useDialect";

export const useCulture = () => {
  const { availableCultures } = useGlobalContext();
  // TODO: Remove the useDialect hook once the term "dialect" is fully replaced with "contentCulture" throughout the codebase.
  const {
    currentDialect: currentContentCulture,
    setCurrentDialect: setContentCulture,
  } = useDialect();

  const enabledCultures = availableCultures.filter(
    (culture) => culture.isEnabled,
  );

  const otherCultures = availableCultures.filter(
    (culture) => !culture.isEnabled,
  );

  return {
    enabledCultures,
    otherCultures,
    availableCultures,
    currentContentCulture,
    setContentCulture,
  };
};
